const digits = (value) => String(value || "").replace(/\D+/g, "");

export default function AutoContactStrip({ siteProfile = {} } = {}) {
  const name = siteProfile.name || "Auto portal";
  const phone = siteProfile.phone || "";
  const phoneDigits = digits(phone);
  const email = siteProfile.email || "";
  const location = siteProfile.location || "";
  const mapsHref = location
    ? `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(location)}`
    : "";

  if (!phoneDigits && !email && !mapsHref) return null;

  return (
    <aside className="auto-contact-strip" aria-label={`${name} contact information`}>
      <div className="auto-contact-strip__inner">
        {phoneDigits ? (
          <a href={`tel:${phoneDigits}`}>
            <i className="ti ti-phone-call" />
            <span>{phone}</span>
          </a>
        ) : null}
        {email ? (
          <a href={`mailto:${email}`}>
            <i className="ti ti-mail" />
            <span>{email}</span>
          </a>
        ) : null}
        {phoneDigits ? (
          <a href={`https://wa.me/1${phoneDigits}`} target="_blank" rel="noreferrer">
            <i className="ti ti-brand-whatsapp" />
            <span>WhatsApp</span>
          </a>
        ) : null}
        {mapsHref ? (
          <a href={mapsHref} target="_blank" rel="noreferrer">
            <i className="ti ti-map-pin" />
            <span>{location}</span>
          </a>
        ) : null}
      </div>
    </aside>
  );
}
